/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    incidentTypeIdSelected:0,
    defaultDataIncidentType:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_INCIDENT_TYPE_ID = 'SET_INCIDENT_TYPE_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setIncidentTypeId = (payload) => ({
  type: SET_INCIDENT_TYPE_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_INCIDENT_TYPE_ID:
        return {
          ...state,
        incidentTypeIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataIncidentType: payload,
          }
     default:
       return state
   }
 }
 